import { useMutation } from '@apollo/client';
import { graphql } from '../gql';
import { GET_SUBMISSION } from './submission.query';
import { GET_QUOTES } from './quotes.query';

const UNDO_QUOTE_PACKAGE_MUTATION = graphql(`
  mutation undoQuotePackage($submissionUuid: String!) {
    undoQuotePackage(submissionUuid: $submissionUuid) {
      uuid
      status
    }
  }
`);

export function useUndoQuotePackageMutation() {
  const [undoQuotePackage, { data, loading, error, reset }] = useMutation(
    UNDO_QUOTE_PACKAGE_MUTATION,
    {
      refetchQueries: [GET_SUBMISSION, GET_QUOTES],
      awaitRefetchQueries: true,
    }
  );

  return {
    data,
    undoQuotePackage,
    loading,
    error,
    reset,
  };
}

export function useUndoQuotePackageWithoutRefetchMutation() {
  const [undoQuotePackage, { data, loading, error, reset }] = useMutation(
    UNDO_QUOTE_PACKAGE_MUTATION
  );

  return {
    data,
    undoQuotePackage,
    loading,
    error,
    reset,
  };
}
